// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"3ab5f6a5","292":"5d909f7a","470":"36bae533","770":"cdc89d41"}[chunkId] + ".chunk.js";
};